import React, { useState } from "react";
import "./style/CreativeStyle.css";
import EmojiPicker from "emoji-picker-react";

interface StepProps {
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  formData: {
    dailyCap: string;
    adName: string;
    title: string;
    description1: string;
    description2: string;
    displayURL: string;
    destinationURL: string;
    trafficSourceType: string;
    frequencyFilter: string;
    imgLocation: string;
    [key: string]: string;
  };

  setFormData: React.Dispatch<React.SetStateAction<any>>;  // <-- Add this line


}

const CreativeStep: React.FC<StepProps> = ({ handleInputChange, formData, setFormData }) => {
  const [imagePreview, setImagePreview] = useState<string | null>(null);

  const [pickerState, setPickerState] = useState<{
    title: boolean;
    description1: boolean;
    description2: boolean;
  }>({
    title: false,
    description1: false,
    description2: false,
  });




  const handleEmojiClick = (
    emojiData: { emoji: string },
    field: "title" | "description1" | "description2"
  ) => {
    const updatedValue = formData[field] + emojiData.emoji;
    handleInputChange({
      target: {
        name: field,
        value: updatedValue,
      },
    } as React.ChangeEvent<HTMLInputElement>);
    setPickerState((prev) => ({ ...prev, [field]: false })); // Close picker after selection
  };

  const togglePicker = (field: "title" | "description1" | "description2") => {
    setPickerState((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };
  
  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (file) {
      const imageName = file.name; // Extract file name
      const reader = new FileReader();
      reader.onload = () => {
        setImagePreview(reader.result as string);
      };
      reader.readAsDataURL(file);

      setFormData((prev: any) => ({ ...prev, imgLocation: imageName }));

      // ✅ Call handleImageChange and pass the event
      handleImageChange(e);
    }
  };

  const handleImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
  
      try {
        // Determine base URL for API request
        const baseUrl =
          window.location.hostname === "localhost"
            ? "http://localhost:5000/api/campaigns/upload"
            : "https://bidvertiser-api.vercel.app/api/campaigns/upload";
  
        const response = await fetch(baseUrl, {
          method: "POST",
          body: formData,
        });
  
        const data = await response.json();
        if (response.ok) {
          setFormData((prev: any) => ({
            ...prev,
            imgLocation: data.fileUrl, // ✅ Store actual image URL
          }));
          setImagePreview(URL.createObjectURL(file)); // Show preview
        } else {
          console.error("Upload failed:", data.message);
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    }
  };
  

  return (
    <>
      <div className="MainSection">
        <div className="CreativePara">
          <p>
            Use the form below to name your ad, choosing its type, entering a title, two lines of
            description, and a URL.
          </p>
          <h1 style={{ fontSize: "14px" }}>Landing Page Guidance:</h1>
          <p>
            No malicious, malware, flash updates, fake virus warnings, auto downloads, scareware, or
            tech support.
            <br />
            These restrictions also apply to affiliate smartlinks, so make sure that your provider
            excludes such offers.
            <br />
            Failure to do so may lead to account suspension.
          </p>
        </div>

        <div className="FormSection">
          <form className="FormCreative">
            <div
              className="labelCreative"
              style={{
                border: "solid",
                borderWidth: "0 0 1px 0",
                padding: "12px 0px",
                borderColor: "#888",
              }}
            >
              <label className="labelHeading">Name your Ad:</label> <br />
              <input
                type="text"
                name="adName"
                maxLength={25}
                value={formData.adName}
                onChange={handleInputChange}
              />
              {/* <span style={{ fontSize: "12px", color: "#888", margin: "0 5px" }}>
                {formData.adName.length || 0}/25
              </span> */}
              <small style={{ color: "#888" }}>(Won't be seen by web visitors)</small>
            </div>

            {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
            {/* Title Section Startrs Here | */}
            {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}


            <div style={{ gap: '300px', display: 'flex', borderWidth: '0px 0px 1px 0px', border: 'none', borderColor: '#888', padding: '0 0 20px 0' }}>

              <div className="">
                <div style={{ position: "relative", margin: "10px 0px 5px 0px", width: "400px" }}>
                  <label className="labelHeading">Title:</label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      padding: "8px",
                    }}
                  >
                    <input
                      type="text"
                      name="title"
                      value={formData.title}
                      onChange={handleInputChange}
                      placeholder="Ad title"
                      maxLength={25}
                      style={{
                        border: "none",
                        outline: "none",
                        flex: 1,
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => togglePicker("title")}

                      style={{
                        borderTopWidth: ' 0',
                        borderRightWidth: "0",
                        borderBottomWidth: "0",
                        borderLeftWidth: '1px',
                        borderColor: '#888',
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "16px",
                        marginLeft: "8px",
                      }}
                    >
                      😊
                    </button>
                    {pickerState.title && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          right: "0",
                          zIndex: 1000,
                        }}
                      >
                        <EmojiPicker
                          onEmojiClick={(emojiData) =>
                            handleEmojiClick(emojiData, "title")
                          }
                        />
                      </div>
                    )}
                    {/* <div style={{ fontSize: "12px", color: "#888" }}>{formData.title.length || 0}/25</div> */}
                  </div>

                </div>


                {/* ------------------------------------------------------------------------------------------------------------------------- */}

                <div style={{ position: "relative", margin: "10px 0px 5px 0px", width: "400px" }}>
                  <label className="labelHeading">Description 1:</label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      padding: "8px",
                    }}
                  >
                    <input
                      type="text"
                      name="description1"
                      value={formData.description1}
                      maxLength={35}
                      onChange={handleInputChange}
                      placeholder="First line of description"
                      style={{
                        border: "none",
                        outline: "none",
                        flex: 1,
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => togglePicker("description1")}
                      style={{
                        background: "none",
                        border: "none",
                        borderTopWidth: ' 0',
                        borderRightWidth: "0",
                        borderBottomWidth: "0",
                        borderLeftWidth: '1px',
                        borderColor: '#888',
                        cursor: "pointer",
                        fontSize: "16px",
                        marginLeft: "8px",
                      }}
                    >
                      😊
                    </button>
                    {pickerState.description1 && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          right: "0",
                          zIndex: 1000,
                        }}
                      >
                        <EmojiPicker
                          onEmojiClick={(emojiData) =>
                            handleEmojiClick(emojiData, "description1")
                          }
                        />
                      </div>
                    )}
                    {/* <div style={{ fontSize: "12px", color: "#888" }}>{formData.description1.length}/35</div> */}
                  </div>

                </div>



                {/* ------------------------------------------------------------------------------------------------------------------------- */}




                {/* ------------------------------------------------------------------------------------------------------------------------- */}

                <div style={{ position: "relative", margin: "10px 0px 5px 0px", width: "400px" }}>
                  <label className="labelHeading">Description 2:</label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      padding: "8px",
                    }}
                  >
                    <input
                      type="text"
                      name="description2"
                      value={formData.description2}
                      maxLength={35}
                      onChange={handleInputChange}
                      placeholder="First line of description"
                      style={{
                        border: "none",
                        outline: "none",
                        flex: 1,
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => togglePicker("description2")}
                      style={{
                        borderTopWidth: ' 0',
                        borderRightWidth: "0",
                        borderBottomWidth: "0",
                        borderLeftWidth: '1px',
                        borderColor: '#888',
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "16px",
                        marginLeft: "8px",
                      }}
                    >
                      😊
                    </button>
                    {pickerState.description2 && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          right: "0",
                          zIndex: 1000,
                        }}
                      >
                        <EmojiPicker
                          onEmojiClick={(emojiData) =>
                            handleEmojiClick(emojiData, "description2")
                          }
                        />                    </div>
                    )}
                    {/* <div style={{ fontSize: "12px", color: "#888" }}>{formData.description2.length}/35</div> */}
                  </div>

                </div>



                {/* ------------------------------------------------------------------------------------------------------------------------- */}

                <div style={{ position: "relative", margin: "10px 0px 5px 0px", width: "400px" }}>
                  <label className="labelHeading">Display URL : <i className="fa fa-info-circle"></i>
                  </label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      padding: "8px",
                    }}
                  >
                    <input
                      type="text"
                      name="displayURL"
                      value={formData.displayURL}
                      maxLength={35}
                      onChange={handleInputChange}
                      placeholder="www.yourwebsitename.com"
                      style={{
                        border: "none",
                        outline: "none",
                        flex: 1,
                      }}
                    />

                    {/* <div style={{ fontSize: "12px", color: "#888" }}>{formData.displayURL.length}/35</div> */}
                  </div>

                </div>
              </div>

              {/* Ad Preview */}
              <div className="AdPreview" style={{ maxWidth: '350px', marginTop: "20px", padding: "0px", border: "1px solid #ccc" }}>
                {imagePreview && (
                  <img src={imagePreview} alt="Preview" style={{ width: "100%", height: "auto", marginTop: "10px" }} />
                )}
                <div style={{ backgroundColor: '#FFFFFF' }}>
                  <p style={{ fontWeight: "bold", fontSize: "16px" }}>{formData.title || "Ad Title"}</p>
                  <p>{formData.description1 || "First line of description"}</p>
                  <p>{formData.description2 || "Second line of description"}</p>
                  <p style={{ color: "#888" }}>{formData.displayURL || "www.yourwebsitename.com"}</p>

                </div>

              </div>


            </div>

            {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
            {/* Title Section Ends Here | */}
            {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
            <hr style={{ color: "#888" }}></hr>



            <div style={{ position: "relative", margin: "10px 0px 5px 0px", width: "800px" }}>
              <label className="labelHeading">Destination URL / Tel:  <i className="fa fa-info-circle"></i>
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  padding: "8px",
                }}
              >
                <input
                  type="text"
                  name="destinationURL"
                  value={formData.destinationURL}
                  // maxLength={35}
                  onChange={handleInputChange}
                  placeholder="https://"
                  style={{
                    border: "none",
                    outline: "none",
                    flex: 1,
                  }}
                />
              </div>
            </div>

            {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
            {/* Title Section Ends Here | */}
            {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}

            {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
            {/* Radio buttons Section starts Here | */}
            {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}



            <hr style={{ marginTop: '30px', color: "#888", fontSize: '12px' }}></hr>

            <div style={{ display: 'flex', marginTop: '30px', gap: '100px', fontSize: '12px' }}>
              <label>Traffic Source Type:  <i className="fa fa-info-circle"></i>
              </label>
              <div >
                <label style={{ marginRight: '50px' }}>
                  <input
                    type="radio"
                    name="trafficSourceType"
                    value="Mainstream"
                    checked={formData.trafficSourceType === "Mainstream"}
                    onChange={handleInputChange}
                  />
                  Mainstream
                </label>
                <label style={{ marginRight: '50px' }}>
                  <input
                    type="radio"
                    name="trafficSourceType"
                    value="Porn"
                    checked={formData.trafficSourceType === "Porn"}
                    onChange={handleInputChange}
                  />
                  Porn
                </label>


              </div>
              <p style={{ color: '#888', marginTop: '0px' }}>
                (Adult campaigns must use "Porn" traffic source type)
              </p>
            </div>


            <hr style={{ marginTop: '20px', color: "#888" }}></hr>



            {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
            {/*  Ends Here | */}
            {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}


            {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
            {/*  Img upload section starts Here | */}
            {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
            <div style={{ lineHeight: '10px' }}>
              <p> <b>Optional: </b> Upload an image in a format of GIF / JPG / JPEG / PNG [recommended image size: 300 x 200]
                <br></br>
                •  You can crop your image to the correct size on the next page <br></br>
                •  Maximum file size to upload for cropping is 2MB</p>

              <div style={{ display: 'flex' }}>
                <label
                  htmlFor="imageInput"
                  style={{
                    display: 'inline-block',
                    padding: '20px 20px',
                    backgroundColor: '#1B3A5E',
                    color: '#fff',
                    cursor: 'pointer',
                    fontSize: '16px',
                    textAlign: 'center',
                    marginRight:'7px'
                  }}
                >
                  Choose an Image
                </label>
                <input
                  id="imageInput"
                  type="file"
                  onChange={handleImageUpload}
                 style={{display: 'none'}}
                />
                {formData.imgLocation && <p>Uploaded: {formData.imgLocation}</p>}

              </div>
            </div>





            {/* <div>
              <input type="file" onChange={handleImageUpload} />
              {formData.imgLocation && <p>Uploaded: {formData.imgLocation}</p>}
            </div> */}


            <hr style={{ marginTop: '20px', color: "#888" }}></hr>


            {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
            {/*  Img upload section Ends Here | */}
            {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}



            {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
            {/*  ImFilter section start here  | */}
            {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}


            <div style={{ fontSize: '12px' }}>
              <label >Frequency Filter:</label> <i className="fa fa-info-circle"></i> <br></br>
              <select
                style={{ marginTop: '10px', width: '150px', height: '35px', padding: '10px' }}
                name="frequencyFilter"
                value={formData.frequencyFilter}
                onChange={handleInputChange}
              >
                <option value="8 Hours">8 Hours</option>
                <option value="24 Hours">24 Hours</option>
                <option value="No Limit">No Limit</option>
              </select>
              <small style={{ marginLeft: '14px' }}>
                Your campaign will receive the same visitor no more than once per selected time.
              </small>
            </div>



            <hr style={{ marginTop: '20px', color: "#888" }}></hr>


            {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
            {/*  ImFilter section End here  | */}
            {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}



            <div style={{display:'none'}} >
              <label>Daily Cap:</label>
              <input
                type="text"
                name="dailyCap"
                value={formData.dailyCap}
                onChange={handleInputChange}
                placeholder="Enter Daily Cap Details"
              />
            </div>

            <button type="submit" style={{display:'none'}}>Submit</button>
          </form>
        </div>
      </div>
    </>
  );
};

export default CreativeStep;
